module.exports = __webpack_public_path__ + "img/documents.a6079e1a.svg";